"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var initialise_exports = {};
__export(initialise_exports, {
  defaultInitialiseOpts: () => defaultInitialiseOpts,
  initialiseBlock: () => initialiseBlock,
  initialiseContent: () => initialiseContent,
  initialiseField: () => initialiseField,
  initialiseForm: () => initialiseForm,
  initialisePage: () => initialisePage
});
module.exports = __toCommonJS(initialise_exports);
var import_topo_core = require("@cartographerio/topo-core");
var import_topo_survey = require("@cartographerio/topo-survey");
var import_fp = require("@cartographerio/fp");
var import_geometry = require("@cartographerio/geometry");
var import_guard = require("@cartographerio/guard");
var import_types = require("@cartographerio/types");
var import_util = require("@cartographerio/util");
var import_lodash = require("lodash");
var import_guard2 = require("./guard.js");
var import_nullable = require("./nullable.js");
const defaultInitialiseOpts = {
  genUserRef: () => (0, import_types.userRef)(),
  genAttachmentFolder: import_types.randomAttachmentFolder,
  genTimestamp: import_types.nowTimestamp,
  genPoint: () => import_geometry.commonLocations.greatBritain.center
};
function initialiseField(field, parentPath, doc, opts = defaultInitialiseOpts) {
  const path = (0, import_topo_core.appendPath)(parentPath, field.path);
  const initialise = (defaultValue, guard, fallbackValue) => {
    if (defaultValue === void 0) {
      return guard((0, import_topo_core.pathGet)(doc, path)) ? import_fp.Result.pure(doc) : (0, import_topo_core.pathSet)(doc, path, fallbackValue());
    } else {
      return (0, import_topo_core.pathSet)(doc, path, defaultValue);
    }
  };
  const nullable = (0, import_nullable.fieldIsNullable)(field);
  switch (field.type) {
    case "TextField":
    case "TextArea":
    case "Autocomplete":
      return initialise(
        field.defaultValue,
        nullable ? (0, import_guard.isNullable)(import_guard.isString) : import_guard.isString,
        nullable ? () => null : () => ""
      );
    case "IntegerField":
    case "NumberField":
      return initialise(field.defaultValue, (0, import_guard.isNullable)(import_lodash.isNumber), () => null);
    case "UserRefField":
      return initialise(
        void 0,
        nullable ? (0, import_guard.isNullable)(import_types.isUserRef) : import_types.isUserRef,
        nullable ? () => null : opts.genUserRef
      );
    case "TimestampField":
      return initialise(
        field.defaultValue === "now" ? opts.genTimestamp() : field.defaultValue,
        nullable ? (0, import_guard.isNullable)(import_types.isTimestamp) : import_types.isTimestamp,
        nullable ? () => null : opts.genTimestamp
      );
    case "AttachmentField":
      return initialise(void 0, import_types.isAttachmentFolder, opts.genAttachmentFolder);
    case "TeamField":
      return initialise(void 0, nullable ? (0, import_guard.isNullable)(import_types.isTeamRef) : import_types.isTeamRef, () => null);
    case "PointField":
      return initialise(field.defaultValue, (0, import_guard.isNullable)(import_geometry.isPoint), () => null);
    case "LineStringField":
      return initialise(field.defaultValue, (0, import_guard.isNullable)(import_geometry.isLineString), () => null);
    case "PolygonField":
      return initialise(field.defaultValue, (0, import_guard.isNullable)(import_geometry.isPolygon), () => null);
    case "FeatureField":
      return initialise(field.defaultValue, (0, import_guard.isNullable)(import_geometry.isFeature), () => null);
    case "NearestFeatureField":
      return initialise(field.defaultValue, (0, import_guard.isNullable)(import_geometry.isPicked), () => null);
    case "Checkbox":
      return initialise(field.defaultValue, import_guard.isBoolean, () => false);
    case "Select": {
      const isValue = (0, import_guard.isOneOf)(field.options.map((opt) => opt.value));
      return initialise(field.defaultValue, (0, import_guard.isNullable)(isValue), () => null);
    }
    case "MultiSelect":
      return initialise(field.defaultValue, import_guard.isArray, () => []);
    default:
      (0, import_util.checkExhausted)(field);
  }
}
function initialiseContent(block, schema, parentPath, doc, opts = defaultInitialiseOpts) {
  switch (block.type) {
    case "DynamicValue":
    case "DynamicGrid":
    case "DynamicImage":
    case "Heading":
    case "Text":
    case "PrimarySurveyorField":
    case "PrimaryTeamField":
      return import_fp.Result.pure(doc);
    case "Group":
      return import_fp.Result.reduce(
        block.blocks,
        doc,
        (survey, block2) => initialiseBlock(block2, schema, parentPath, survey, opts)
      );
    case "Repeat": {
      const arrayPath = (0, import_topo_core.appendPath)(parentPath, block.path);
      const arraySchema = (0, import_topo_survey.schemaRef)(schema, block.path) ?? import_topo_survey.unknownSchema;
      const targetLength = block.defaultLength ?? 0;
      return import_fp.Result.pass(arraySchema).guardWith(
        (s) => (0, import_topo_survey.isSchema)(s) && (0, import_topo_survey.isArraySchema)(import_topo_survey.isAnySchema)(s),
        () => (0, import_topo_core.errorMessage)("Schema for repeat block isn't an array", arrayPath, schema)
      ).flatMap(
        (arraySchema2) => initialiseBlock(block.block, arraySchema2.param, [], (0, import_topo_survey.schemaBlankValue)(arraySchema2.param), opts)
      ).map((arrayItem) => new Array(targetLength).fill(arrayItem)).flatMap((array) => (0, import_topo_core.pathSet)(doc, arrayPath, array));
    }
    case "Card":
    case "FullWidth":
    case "Visibility":
    case "RequireRole":
      return initialiseBlock(block.block, schema, parentPath, doc, opts);
    case "Scope": {
      return initialiseBlock(
        block.block,
        (0, import_topo_survey.schemaRef)(schema, block.path) ?? import_topo_survey.unknownSchema,
        (0, import_topo_core.appendPath)(parentPath, block.path),
        doc,
        opts
      );
    }
    default:
      return (0, import_util.checkExhausted)(block);
  }
}
function initialiseBlock(block, schema, parentPath, doc, opts = defaultInitialiseOpts) {
  if ((0, import_guard2.isField)(block)) {
    return initialiseField(block, parentPath, doc, opts);
  } else {
    return initialiseContent(block, schema, parentPath, doc, opts);
  }
}
function initialisePage(page, schema, parentPath, doc, opts = defaultInitialiseOpts) {
  const path = (0, import_topo_core.appendPath)(parentPath, page.path);
  return import_fp.Result.reduce(page.blocks, doc, (survey, block) => initialiseBlock(block, schema, path, survey, opts));
}
function initialiseForm(form, schema, path, doc, opts = defaultInitialiseOpts) {
  return import_fp.Result.reduce(form.pages, doc, (survey, page) => {
    const pageSchema = (0, import_topo_survey.schemaRef)(schema, page.path) ?? import_topo_survey.unknownSchema;
    return initialisePage(page, pageSchema, path, survey, opts);
  });
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  defaultInitialiseOpts,
  initialiseBlock,
  initialiseContent,
  initialiseField,
  initialiseForm,
  initialisePage
});
//# sourceMappingURL=initialise.js.map
